import { memo, useEffect } from 'react';
import Image from 'next/image';
import { Box, Typography } from '@mui/material';
import { useRouter } from 'next/router';

import {
  updateSelectedFreq,
  updateSelectedPlan,
  usePersistentplanAndFreq,
} from 'store/planAndFreq';
import { usePersistentPromoCodeDetails } from 'store/promoCode';

import { plansType } from '@utils/types';
import { STEP_ONE_SIDE_IMG } from '@utils/data';
import PlanAndPriceButtonGroup from '@components/PlanAndPriceButtonGroup';

import { useStyles } from './useStyles';
import theme from 'src/style-system/theme';
import FrequencyButtonGroup from '@components/FrequencyButtonGroup';

interface IPlan {
  plans: plansType[] | undefined;
  frequencies: string[] | undefined;
  updatePlan: (plan: number, planId: number) => void;
  countryCode: string;
}

const PlanAndFreq = ({
  plans,
  frequencies,
  updatePlan,
  countryCode,
}: IPlan) => {
  const planAndFreq = usePersistentplanAndFreq();
  const promoCodeDetails = usePersistentPromoCodeDetails();

  const router = useRouter();

  const { TRAIL_PLAN } = router?.query;

  const classes = useStyles();

  useEffect(() => {
    if (!TRAIL_PLAN) {
      //for freq
      if (!frequencies?.length) {
        updateSelectedFreq('');
      } else if (
        planAndFreq?.selectedFrequency &&
        frequencies?.filter((freq) => freq === planAndFreq?.selectedFrequency)
          ?.length
      ) {
        updateSelectedFreq(planAndFreq?.selectedFrequency);
      } else if (frequencies?.length) {
        updateSelectedFreq(frequencies[0]);
      }

      const isSelectedPlanExist = plans
        ? plans[0]?.filter((plan) => plan.id === planAndFreq?.selectedPlanId)
        : [];

      // for plan
      if (planAndFreq?.selectedPlan && plans && isSelectedPlanExist?.length) {
        // case for already selected plan
        updateSelectedPlan(
          planAndFreq?.selectedPlan,
          planAndFreq?.selectedPlanId
        );
      } else {
        // case for no selected plan
        if (plans?.length) {
          updateSelectedPlan(plans[0][1]?.count_of_dishes, plans[0][1]?.id);
        }
      }
    }
  }, [plans, frequencies, TRAIL_PLAN]);

  return (
    <Box bgcolor="whitePepper.main" className={classes.mainContainer}>
      <Box className={classes.heroSectionImgWrapper}>
        <Image
          src={STEP_ONE_SIDE_IMG}
          alt="Dish Pack"
          layout="fill"
          objectFit="contain"
        />
      </Box>
      {TRAIL_PLAN ? null : (
        <Box className={classes.btnWrapper}>
          <Typography variant="body1" color="garamMasala.main">
            Plan Size
          </Typography>
          <Typography variant="caption" color="cinnamon.main" mb="12px">
            Each meal serves 1 adult
          </Typography>
          <Box
            sx={{
              marginBottom: '25px',
            }}
          >
            <PlanAndPriceButtonGroup plans={plans} />
          </Box>
          <Typography variant="body1" color="garamMasala.main" align="center">
            Frequency
          </Typography>
          <Typography
            variant="caption"
            color="cinnamon.main"
            align="left"
            mb="12px"
          >
            Pause/cancel anytime, no questions asked
          </Typography>
          <FrequencyButtonGroup frequencies={frequencies} />
          {promoCodeDetails?.isPromoValid &&
          (promoCodeDetails?.amountType === 'FREE_MEALS' ||
            promoCodeDetails?.amountType === 'FREE_GIFTS') ? (
            <Typography variant="body1" color="garamMasala.main" mb="12px">
              {promoCodeDetails?.amountType === 'FREE_MEALS'
                ? `Free meals have been added to your cart!`
                : 'Welcome gift added to cart!'}
            </Typography>
          ) : null}
        </Box>
      )}
    </Box>
  );
};

export default memo(PlanAndFreq);
